<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        <component-header
          title="Service Request Create Subcategory"
          :hasSearch="false"
          :hasReload="false"
          :hasCreate="false"
          :hasback="true"
          @back-press="
            $router.push({
              name: 'View Request',
              params: { data: $route.params.data },
            })
          "
        />
      </b-col>
      <b-col md="12">
        <b-card>
          <b-row>
            <b-col md="4">
              <span>Category</span>
            </b-col>
            <b-col md="8">
              <c-input inputType="text" lableText="Category" v-model="name" />
            </b-col>
          </b-row>
          <b-row v-if="userRole === 'Tenant' || userRole === 'Partner'">
            <b-col md="4">
              <span>Scope</span>
            </b-col>
            <b-col md="8">
              <eb-select
                type="text"
                v-model="scope"
                :options="scope1Options"
                label="label"
                placeholder="Select scope"
              ></eb-select>
            </b-col>
          </b-row>
          <b-row v-if="userRole === 'Admin'">
            <b-col md="4">
              <span>Scope</span>
            </b-col>
            <b-col md="8">
              <eb-select
                type="text"
                v-model="scope"
                :options="scopeOptions"
                label="label"
                placeholder="Select scope"
              ></eb-select>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="4">
              <span>Description</span>
            </b-col>
            <b-col md="8">
              <b-form-textarea
                v-model="description"
                placeholder="Enter something..."
                rows="3"
                max-rows="6"
              ></b-form-textarea>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <span>Severity</span>
            </b-col>
            <b-col md="8">
              <eb-select
                type="text"
                v-model="severity"
                :options="severityOptions"
                label="label"
                placeholder="Select Severity"
              ></eb-select>
            </b-col>
          </b-row>
        </b-card>
        <div class="text-center mb-3">
          <eb-button
            class="btn mr-4"
            classic="mr-1 btn-primary"
            text="Save"
            @click.prevent="handleSubmit"
          ></eb-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import cInput from "@/components/Common/CustomInput";
import ebSelect from "@/components/FormElements/Select.vue";
import ebButton from "@/components/FormElements/Button";
import servicerequestdetails from "@/components/MasterSetup/ServiceRequest/ServiceRequestDetails.vue";
import ComponentHeader from "@/components/componentNewHeader";
import { AtomSpinner } from "epic-spinners";
export default {
  name: "subcategory",
  components: {
    ebButton,
    cInput,
    ebSelect,
    servicerequestdetails,
    ComponentHeader,
  },
  data() {
    return {
      show: true,
      scope1Options: ["AGENT", "PARTNER", "CUSTOMER"],
      scopeOptions: ["TENANT"],
      severityOptions: ["Low", "Medium", "High", "Critical"],
      name: "",
      scope: "",
      description: "",
      severity: "",
      item: "",
    };
  },
  computed: {
    userRole() {
      if (this.$store.getters["auth/getUserRole"]) {
        return this.$store.getters["auth/getUserRole"];
      } else {
        return JSON.parse(sessionStorage.getItem("userLogin"))["role"];
      }
    },
  },
  methods: {
    async handleSubmit() {
      let dataObj;
      dataObj = {
        parent: this.item,
        scope: this.scope,
        name: this.name,
        description: this.description,
        severity: this.severity,
      };
      try {
        await this.$store.dispatch("servicerequest/createSubcategory", dataObj);
        this.$swal({
          title: "Success",
          text: "Category added successfully!!",
          type: "success",
        });
        this.$router.push({
          name: "View Request",
          params: { data: this.$route.params.data },
        });
        this.$store.dispatch("servicerequest/fetchsubcategoryList", this.item);
      } catch (error) {
        this.$toasted.error(data.message);
      }
    },
  },
  async mounted() {
    this.item = this.$route.params.id;
  },
};
</script>
<style scoped>
.fa-plus {
  border-top-right-radius: 10px;
  border-top-left-radius: 17px;
  border-bottom-left-radius: 17px;
  background-color: #f0f3f5;
}
</style>
